
























































































































import { Vue, Component, Watch } from "vue-property-decorator";
import CompanyPageForm from "@/components/companies/CompanyPageForm.vue";
import { getCurrentCompanyId, getCurrentUserId } from "@/plugins/roles";
import { UserCsvImport as IUserCsvImport } from "@/api/models/user-csv-import";
import { UserDocumentInfo as IUserDocumentInfo } from "@/api/models/user-document-info";
import { LearningRequest as ILearningRequest } from "@/api/models/learning-request";
import { Student as IStudent } from "@/api-v2/course/models/student";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import ImportedUsersItem from "@/components/companies/ImportedUsersItem.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import { User as IUser } from "@/api/models/user";
import CustomButton from "@/components/form/CustomButton.vue";
import OrderForm from "@/components/orders/OrderForm.vue";
import { courseApi } from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import OrderItemPreview from "@/components/orders/OrderItemPreview.vue";
import ImportedLearningRequestItem from "@/components/orders/ImportedLearningRequestItem.vue";
import ImportedUsersOrders from "@/components/orders/ImportedUsersOrders.vue";
import { quickDocumentCreationModule } from "@/plugins/modules-detect";

Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate"
]);

@Component({
  components: {
    ImportedUsersOrders,
    ImportedLearningRequestItem,
    OrderItemPreview,
    OrderForm,
    CustomButton,
    CBlock,
    ImportedUsersItem,
    CustomTable,
    CPage,
    CompanyPageForm
  }
})
export default class ImportedUsers extends Vue {
  users: IUserCsvImport[] = [];
  checkedUsersIds: string[] = [];
  highlightedUsers: IUser[] = [];
  orders: ILearningRequest[] = [];
  isShowCreateOrder: boolean = false;
  indeterminate: boolean = false;
  allSelected: boolean = false;
  students: IStudent[] = [];
  data() {
    return {
      companyInfo: undefined
    };
  }

  get isQuickDocumentCreation() {
    return quickDocumentCreationModule();
  }

  get checkedUsers(): IUser[] {
    //@ts-ignore
    return this.users
      .map(el => el.user)
      .filter(elF => {
        return this.checkedUsersIds.some(id => elF?.id === id);
      });
  }

  saveOrder(data: { users: IUser[]; order: ILearningRequest }) {
    this.isShowCreateOrder = false;
    this.orders = [...this.orders, data.order];
    this.highlightedUsers = [...this.highlightedUsers, ...data.users];
  }

  checkHighlighted(id: string) {
    return this.highlightedUsers.map(({ id }) => id).includes(id);
  }

  toggleAll(checked: any) {
    this.checkedUsersIds = checked
      ? this.users.map(el => (el.user ? el.user.id : ""))
      : [];
  }

  @Watch("checkedUsers")
  selected(newValue: any, oldValue: any) {
    // Handle changes in individual flavour checkboxes
    if (newValue.length === 0) {
      this.indeterminate = false;
      this.allSelected = false;
    } else if (newValue.length === this.users.length) {
      this.indeterminate = false;
      this.allSelected = true;
    } else {
      this.indeterminate = true;
      this.allSelected = false;
    }
  }

  generateStudents() {
    this.checkedUsers.forEach(el => {
      courseApi.Student.createStudent({
        firstName: el.firstName ? el.firstName : "",
        lastName: el.lastName ? el.lastName : "",
        middleName: el.middleName,
        userId: el.id,
        companyId: this.company
      })
        .then(res => {
          this.students = [...this.students, res.data];
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        });
    });
  }

  get userId() {
    return getCurrentUserId();
  }

  get company() {
    return getCurrentCompanyId();
  }

  // beforeRouteLeave(to: any, from: any, next: any) {
  //   const answer = window.confirm(
  //     "Do you really want to leave? you have unsaved changes!"
  //   );
  //   if (answer) {
  //     next();
  //   }
  // }

  saveUser(U: IUser) {
    let index = this.users.findIndex(el => el?.user?.id === U.id);
    this.users[index].user = U;
    localStorage.setItem("importedUsers", JSON.stringify(this.users));
  }

  saveUserDocumentInfo(UD: IUserDocumentInfo) {
    let index = this.users.findIndex(el => el?.user?.id === UD.userId);
    this.users[index].userDocumentInfo = UD;
    localStorage.setItem("importedUsers", JSON.stringify(this.users));
  }

  mounted() {
    let U = localStorage.getItem("importedUsers");
    if (U) {
      this.users = JSON.parse(U);
    }
  }
  beforeRouteLeave(to: any, from: any, next: any) {
    // If the form is dirty and the user did not confirm leave,
    // prevent losing unsaved changes by canceling navigation
    if (this.confirmStayInDirtyForm()) {
      next(false);
    } else {
      // Navigate to next view
      next();
    }
  }

  created() {
    window.addEventListener("beforeunload", this.beforeWindowUnload);
  }

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.beforeWindowUnload);
  }

  confirmLeave() {
    return window.confirm(
      `${this.$tc(this.$translate.TheChangesYouMadeMayNotBeSaved)}`
    );
  }

  confirmStayInDirtyForm() {
    return !this.confirmLeave();
  }

  beforeWindowUnload(e: any) {
    if (this.confirmStayInDirtyForm()) {
      // Cancel the event
      e.preventDefault();
      // Chrome requires returnValue to be set
      e.returnValue = "";
    }
  }

  // beforeDestroy() {
  //   localStorage.removeItem("importedUsers");
  // }
}
